import React, { forwardRef, Ref } from 'react';
import { SimpleIconProps } from '../icon.types';
import Icon from './Icon';

const svg = `<svg viewBox="0 0 24 24" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" fill="none">
  <path d="M18 6 6 18"/>
  <path d="m6 6 12 12"/>
</svg>`;

const Close = forwardRef(
  (props: SimpleIconProps, ref: Ref<SVGSVGElement> | undefined) => (
    <Icon ref={ref} name='close' svg={svg} {...props} />
  )
);

Close.displayName = 'CloseIcon';

export default Close;
